/* RemixSkin.js */

import React from 'react';
import { Col, Row } from 'reactstrap';
import Skins from '../../enums/Skins';

export default function RemixSkin({ parentSkin, setParentSkin, callback }) {
  return (
    <Row>
      {Skins.map((item) => (
        <Col className='mb-2' md={2} key={item.id}>
          <div
            className={`shadow skin-preview tbg${item.id} cursor-pointer ${(parentSkin === item.id) ? 'selected' : '' }`}
            onClick={() => {
              if (setParentSkin) { setParentSkin(item.id); }
              if (callback) { callback(item.id); }
            }}
          >
          </div>
        </Col>
      ))}
    </Row>
  );
}
